import { useCallback } from 'react';
import { app as teamsApp, authentication } from '@microsoft/teams-js';
import {
  bestEffortNameFromContext,
  resolveTeamsIdentity,
  type TeamsContextLike,
} from '../services/teamsIdentity';

export const useTeamsViewerIdentity = () => {
  const resolveViewerIdentity = useCallback(async (): Promise<{
    displayName: string | null;
    participantId: string | null;
  }> => {
    try {
      await teamsApp.initialize();
      const context = (await teamsApp.getContext()) as unknown as TeamsContextLike;
      const identity = await resolveTeamsIdentity({
        authentication,
        context,
      });

      return {
        displayName: identity.displayName,
        participantId: identity.participantId,
      };
    } catch {
      try {
        const context = (await teamsApp.getContext()) as unknown as TeamsContextLike;
        return {
          displayName: bestEffortNameFromContext(context),
          participantId: null,
        };
      } catch {
        return {
          displayName: null,
          participantId: null,
        };
      }
    }
  }, []);

  const resolveViewerDisplayName = useCallback(async (): Promise<string | null> => {
    const identity = await resolveViewerIdentity();
    return identity.displayName;
  }, [resolveViewerIdentity]);

  return {
    resolveViewerIdentity,
    resolveViewerDisplayName,
  };
};
